import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
import { isActiveInsider } from "../visibilityFunctions/shared-utils";
import { GoToMembershipSettingsCTA, InsiderBenefitsLearnMoreCTA } from "./ctas";
export var BenefitsIA = function BenefitsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return isActiveInsider() ? INSIDER_RETAILER(strictLocalize) : NON_INSIDER_RETAILER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return isActiveInsider() ? GoToMembershipSettingsCTA(strictLocalize) : InsiderBenefitsLearnMoreCTA(strictLocalize);
};
var INSIDER_RETAILER = function INSIDER_RETAILER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INSIDER_MEMBERSHIP_BENEFITS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WITH_YOUR_INSIDER_MEMBERSHIP(strictLocalize)];
    }
  };
};
var NON_INSIDER_RETAILER = function NON_INSIDER_RETAILER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INSIDER_MEMBERSHIP_BENEFITS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WHEN_YOU_SIGN_UP_FOR_INSIDER(strictLocalize)];
    }
  };
};
var INSIDER_MEMBERSHIP_BENEFITS = function INSIDER_MEMBERSHIP_BENEFITS(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "wAVSN/",
    defaultMessage: [{
      "type": 0,
      "value": "Sobre a subscrição Insider"
    }]
  }) : strictLocalize({
    id: "qTpQWl",
    defaultMessage: [{
      "type": 0,
      "value": "Benefícios da subscrição Insider"
    }]
  });
};
var WITH_YOUR_INSIDER_MEMBERSHIP = function WITH_YOUR_INSIDER_MEMBERSHIP(strictLocalize) {
  return strictLocalize({
    id: "ftgnjU",
    defaultMessage: [{
      "type": 0,
      "value": "Com a sua subscrição Insider, tem acesso a envio gratuito em milhares de marcas selecionadas pela Faire. Além disso, tem acesso antecipado exclusivo às feiras virtuais da Faire e aos mais recentes produtos das marcas no nosso site. Para consultar as informações da subscrição Insider, clique no botão abaixo e visite o separador \"Subscrição Insider\" nas definições de conta."
    }]
  });
};
var WHEN_YOU_SIGN_UP_FOR_INSIDER = function WHEN_YOU_SIGN_UP_FOR_INSIDER(strictLocalize) {
  return strictLocalize({
    id: "x20m8m",
    defaultMessage: [{
      "type": 0,
      "value": "Quando se regista numa subscrição Insider, tem acesso ao envio gratuito em milhares de marcas selecionadas pela Faire. Além disso, terá acesso antecipado exclusivo às feiras virtuais da Faire e às marcas recém-chegadas ao site. Para aceder a estes benefícios, basta registar-se num período de avaliação gratuita de 30 dias. Após o período de avaliação, o preço da subscrição será debitado mensalmente na forma de pagamento que selecionar."
    }]
  });
};